<h3 class="text-center width-100">
  Feedback
  <i
    class="fa fa-times pull-right close-sidenav"
    aria-hidden="true"
    title="Close Text Block"
    (click)="closeNav()"
  ></i>
</h3>
<!-- 3 STEP PROCESS FORM: SETTINGS, SEARCH LISTING, AND LISTING RESULTS -->
<div class="container-fluid">
  <!-- SIMPLE INPUTS -->
  <div class="edit row">
    <div class="col-12 margin-5-0">
      <div class="form-group">
        <label for="name">Title</label>
        <input
          type="text"
          class="form-control"
          id="name"
          aria-describedby="title"
          placeholder="Enter Title"
          [(ngModel)]="title"
        />
      </div>
    </div>
    <div class="col-12 margin-5-0">
      <div class="form-group">
        <label for="sendEmail">Send to Email</label>
        <input
          type="text"
          class="form-control"
          id="sendEmail"
          aria-describedby="headline"
          placeholder="Enter sender email"
          [(ngModel)]="sendEmail"
        />
        <small id="buttonClassHelp" class="form-text text-muted"
          >For more than ONE email please use a comma "," to separate email users.</small
        >
      </div>
    </div>

    <div class="col-12 margin-5-0">
      <div class="form-group">
        <label for="sendButton">Send Button Label</label>
        <input
          type="text"
          class="form-control"
          id="sendButton"
          aria-describedby="headline"
          placeholder="Enter Button Description "
          [(ngModel)]="sendButton"
        />
      </div>
    </div>
    <div class="col-12 margin-5-0">
      <div class="form-check">
        <label for="name" class="form-check-label">
          <input
            style="
              width: 20px;
              height: 20px;
              margin-right: 5px;
              position: relative;
              vertical-align: bottom;
            "
            type="checkbox"
            class="form-check-input"
            id="name"
            [(ngModel)]="name"
          />Show Name.
        </label>
      </div>
    </div>
    <div class="col-12 margin-5-0">
      <div class="form-check">
        <label for="phone" class="form-check-label">
          <input
            style="
              width: 20px;
              height: 20px;
              margin-right: 5px;
              position: relative;
              vertical-align: bottom;
            "
            type="checkbox"
            class="form-check-input"
            id="phone"
            [(ngModel)]="phone"
          />Show Phone.
        </label>
      </div>
    </div>
    <div class="col-12 margin-5-0">
      <div class="form-check">
        <label for="showEmail" class="form-check-label">
          <input
            style="
              width: 20px;
              height: 20px;
              margin-right: 5px;
              position: relative;
              vertical-align: bottom;
            "
            type="checkbox"
            class="form-check-input"
            id="showEmail"
            [(ngModel)]="email"
          />Show Email.
        </label>
      </div>
    </div>
    <div class="col-12 margin-5-0">
      <div class="form-check">
        <label for="eachRow" class="form-check-label">
          <input
            style="
              width: 20px;
              height: 20px;
              margin-right: 5px;
              position: relative;
              vertical-align: bottom;
            "
            type="checkbox"
            class="form-check-input"
            id="eachRow"
            [(ngModel)]="emailCheckbox"
          />Show Email Optional Checkbox.
        </label>
      </div>
    </div>
    <div class="col-12 margin-5-0">
      <div class="form-check">
        <label for="resetButton" class="form-check-label">
          <input
            style="
              width: 20px;
              height: 20px;
              margin-right: 5px;
              position: relative;
              vertical-align: bottom;
            "
            type="checkbox"
            class="form-check-input"
            id="restBtn"
            [(ngModel)]="resetButton"
          />Enable Reset Button.
        </label>
      </div>
    </div>
    <div class="col-12 margin-5-0">
      <div class="form-group">
        <label for="placeholder">Text Area Placeholder</label>
        <input
          type="text"
          class="form-control"
          id="placeholder"
          aria-describedby="placeholder"
          placeholder="Enter Placeholder Description "
          [(ngModel)]="placeholder"
        />
      </div>
    </div>
  </div>

  <!-- MORE OPTIONS -->
  <div class="edit row">
    <div class="col-12">
      <button
        role="button"
        type="button"
        aria-label="More Options"
        class="btn btn-link"
        (click)="isCollapsed = !isCollapsed"
      >
        More Options
        <i *ngIf="isCollapsed" class="fa fa-caret-right" aria-hidden="true"></i>
        <i *ngIf="!isCollapsed" class="fa fa-caret-down" aria-hidden="true"></i>
      </button>
    </div>
  </div>
  <div class="width-100 padding-0-25" [ngbCollapse]="isCollapsed">
    <div class="block row text-center margin-15-0">
      <h3>Sender Email</h3>
    </div>
    <div class="edit row">
      <div class="col-12 margin-5-0">
        <div class="form-group">
          <label for="subjectLine">Subject Line</label>
          <input
            type="text"
            class="form-control"
            id="subjectLine"
            aria-describedby="headline"
            placeholder="Enter Subject Line"
            [(ngModel)]="subjectLine"
          />
        </div>
      </div>
      <div class="col-12 margin-5-0">
        <div class="form-group">
          <label for="optionalTxt">Optional Text</label>
          <textarea
            id="optionalTxt"
            class="form-control"
            aria-describedby="Optional Text"
            rows="5"
            [(ngModel)]="optionalTxt"
          ></textarea>
        </div>
      </div>
    </div>
    <div class="block row text-center margin-15-0">
      <h3>Design Styles</h3>
    </div>
    <div class="edit row">
      <div class="col-12 margin-5-0">
        <div class="form-group">
          <label for="color">Font Color</label><br />
          <input
            type="text"
            class="form-control color"
            id="color"
            aria-describedby="Font Color"
            placeholder="Title Color"
            [(ngModel)]="color"
          />
          <button
            role="button"
            type="button"
            aria-label="Choose Color"
            class="btn btn-circle"
            [style.background]="color"
            [(colorPicker)]="color"
          ></button>
        </div>
      </div>
      <div class="col-12 margin-5-0">
        <div class="form-group">
          <label for="background">Background Color</label><br />
          <input
            type="text"
            class="form-control color"
            id="background"
            aria-describedby="Background Color"
            placeholder="Background"
            [(ngModel)]="background"
          />
          <button
            role="button"
            type="button"
            aria-label="Choose Color"
            class="btn btn-circle"
            [style.background]="background"
            [(colorPicker)]="background"
          ></button>
        </div>
      </div>
      <div class="col-12 margin-5-0">
        <div class="form-group">
          <!-- <label for="labelColor">Input, Select, Textarea Font Color</label><br /> -->
          <label for="labelColor">Text Input Area Color</label><br />
          <input
            type="text"
            class="form-control color"
            id="labelColor"
            aria-describedby="Label Font Color"
            placeholder="Input Label"
            [(ngModel)]="labelColor"
          />
          <button
            role="button"
            type="button"
            aria-label="Choose Color"
            class="btn btn-circle"
            [style.background]="labelColor"
            [(colorPicker)]="labelColor"
          ></button>
        </div>
      </div>
      <!-- <div class="col-12 margin-5-0">
                    <div class="form-group">
                        <label for="inputColor">Input Font Color</label><br />
                        <input type="text" class="form-control color"
                                id="inputColor" aria-describedby="Input Font Color"
                                placeholder="Enter Font Color"
                                [(ngModel)]="inputColor"
                                >
                        <button role="button" aria-label="Choose Color" class="btn btn-circle"
                                [style.background]="inputColor"
                                [(colorPicker)]="inputColor"
                                >
                        </button>
                    </div>
                </div> -->
      <div class="col-12 margin-5-0">
        <div class="form-group">
          <label for="inputBackground">Input Background</label><br />
          <input
            type="text"
            class="form-control color"
            id="inputBackground"
            aria-describedby="Input Background"
            placeholder="Input Background"
            [(ngModel)]="inputBack"
          />
          <button
            role="button"
            type="button"
            aria-label="Choose Color"
            class="btn btn-circle"
            [style.background]="inputBack"
            [(colorPicker)]="inputBack"
          ></button>
        </div>
      </div>

      <!--
                <div class="col-12 margin-5-0">
                    <div class="form-group">
                        <label for="buttonClass">Submit Button Class</label>
                        <input type="text" class="form-control"
                                id="buttonClass" aria-describedby="headline"
                                placeholder="button class"
                                [(ngModel)]="btnClass"
                                >
                        <small id="buttonClassHelp" class="form-text text-muted">This button uses Bootstrap Class definitions. More information <a target="_blank" href="https://getbootstrap.com/docs/4.0/components/buttons/">click here</a></small>
                    </div>
                </div> -->

      <!-- <div class="col-12 margin-5-0">
                    <div class="form-group">
                        <label for="className">Additional Classes
                            <i class="fa question-help fa-question-circle-o" aria-hidden="true"
                                matTooltip="Add additional classes through the CSS Editor"
                                [matTooltipPosition]="'after'"
                                ></i>
                        </label>
                        <input type="text" class="form-control"
                                id="className" aria-describedby="headline"
                                placeholder="defined through CSS editor"
                                [(ngModel)]="className"
                                >
                    </div>
                </div> -->
      <div class="col-12 margin-5-0 padding-10-0">
        <div class="form-check">
          <label for="flush" class="form-check-label">
            <input
              style="
                width: 20px;
                height: 20px;
                margin-right: 5px;
                position: relative;
                vertical-align: bottom;
              "
              type="checkbox"
              class="form-check-input"
              id="flush"
              [(ngModel)]="flushed"
            />Flush in template.
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="edit row">
    <div class="col-12 margin-25-0 text-end">
      <button
        role="button"
        type="button"
        aria-label="Preview"
        class="btn btn-link"
        style="left: initial"
        (click)="updateFEED(feed)"
      >
        Preview
      </button>
      <button
        role="button"
        type="button"
        aria-label="Save and Close"
        class="btn btn-primary"
        style="left: initial"
        (click)="submitFEED(feed)"
      >
        Save and Close
      </button>
    </div>
  </div>
</div>
